module.exports = __webpack_public_path__ + "static/images/group-bg.d37d728.png";